<template>
  <v-card outlined class="mx-auto s-layout-small mt-0">
    <v-card-title class="pa-0" style="justify-content: space-between;">
      <p class="ma-0">Thông tin đơn hàng</p>
      <p class="ma-0">{{dataStatusCTV}}</p>
      <!-- <p class="ma-0" v-else>{{dataStatus}}</p> -->
    </v-card-title>
    <v-row>
      <v-col cols="12" sm="12" class="order-products-wrapper" style="overflow: auto">
        <v-simple-table class="table-layout table-small-screen mobile-hidden">
          <template v-slot:default>
            <thead>
              <tr>
                <th>Tên sản phẩm</th>
                <th>Số lượng</th>
                <th>Đơn giá</th>
                <th>Thành tiền</th>
                <!-- <th style="white-space: nowrap;">Tên đại lý</th> -->
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, index) in contentOrder.products" :key="index">
                <td>
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="'Tên Sản Phẩm ' + index"
                    name="Tên sản phẩm"
                    rules="required"
                  >
                    <v-autocomplete
                      :disabled="isReadOnly"
                      v-model="product.productId"
                      :items="courseRegisters"
                      item-text="name"
                      item-value="id"
                      label
                      class="ma-0 pa-0"
                      :error-messages="errors"
                      @change="changeProduct(product)"
                    />
                  </validation-provider>
                </td>
                <td>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Số lượng"
                    :vid="'Số lượng' + index"
                    :rules="{required: true, numeric: true, regex: /^[0-9]+$/, min_value:1, max:4 }"
                  >
                    <v-text-field
                      :readonly="isReadOnly"
                      type="number"
                      v-model="product.quantity"
                      label
                      class="ma-0 pa-0"
                      :error-messages="errors"
                      color="primary"
                    />
                  </validation-provider>
                </td>
                <td>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Đơn giá"
                    :vid="'Đơn giá' + index"
                    :rules="{required: true, numeric: true, regex: /^[0-9]+$/, min_value:0}"
                  >
                    <v-text-field
                      :readonly="isReadOnly"
                      step="5000"
                      type="number"
                      v-model="product.price"
                      label
                      class="ma-0 pa-0"
                      :error-messages="errors"
                      color="primary"
                    />
                  </validation-provider>
                </td>
                <td>
                  <v-currency-field class="ma-0 pa-0" readonly :value="(product.price * product.quantity)" />
                </td>
                <!-- <td>
                  <validation-provider
                    v-slot="{ errors }"
                    :vid="'Tên đại lý' + index"
                    name="Tên đại lý"
                    rules="required"
                  >
                    <v-autocomplete
                      :disabled="isReadOnly || !product.productId"
                      v-model="product.agencyId"
                      :items="agencyList"
                      :menu-props="{ maxHeight: '250',maxWidth: '250',bottom: true, offsetY: true }"
                      item-text="name"
                      item-value="id"
                      class="ma-0 pa-0"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </td> -->
                <td v-show="index > 0 && !isReadOnly" class="text-left" style="position: relative">
                  <div class="border-table-order"></div>
                  <v-btn
                    color="blue"
                    text
                    style="text-transform: inherit; font-weight: bold; font-size: 12px; margin-top: -15px"
                    @click="onClickRemoteProduct(index)"
                  >Xoá</v-btn>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>
                  <v-btn small v-if="!isReadOnly" color="blue" @click="onClickAddProduct">
                    <v-icon>mdi-plus</v-icon>Thêm sản phẩm
                  </v-btn>
                </td>
                <td colspan="2" style="font-weight: bold; text-align: right;">Tổng giá trị đơn hàng:</td>
                <td style="font-weight: bold; text-align: left;">{{formatPrice(totalPrice)}}</td>
              </tr>
            </tfoot>
          </template>
        </v-simple-table>
        <v-expansion-panels class="mb-4 mobile-show" v-model="panel" multiple>
          <v-expansion-panel style="border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;">
            <v-expansion-panel-header class="px-0" id="support-filter-header"><b>Thông tin sản phẩm</b></v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-list-item three-line class="overflow-visible pa-0">
                <v-list-item-content class="overflow-visible pa-0">
                  <div v-for="(product, index) in contentOrder.products" :key="`1${index}`" class="my-3" style="border-bottom: 1px solid black">
                    <div v-if="!isReadOnly && index > 0" style="text-align: right; margin-right: 10px;">
                      <v-btn
                        style="margin-right: -20px;"
                        @click="onClickRemoteProduct(index)"
                        text
                        small
                      >
                        <v-icon>mdi-close-box</v-icon>
                      </v-btn>
                    </div>
                    <validation-provider
                      v-slot="{ errors }"
                      :vid="'Tên Sản Phẩm ' + index"
                      name="Tên sản phẩm"
                      rules="required"
                    >
                      <v-autocomplete
                        :disabled="isReadOnly"
                        v-model="product.productId"
                        :items="courseRegisters"
                        item-text="name"
                        item-value="id"
                        label="Tên sản phẩm"
                        class="ma-0 pa-0 mb-3"
                        :error-messages="errors"
                        @change="changeProduct(product)"
                      />
                    </validation-provider>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Số lượng"
                      :vid="'Số lượng' + index"
                      :rules="{required: true, numeric: true, regex: /^[0-9]+$/, min_value:1, max:4 }"
                    >
                      <v-text-field
                        :readonly="isReadOnly"
                        type="number"
                        v-model="product.quantity"
                        label="Số lượng"
                        class="ma-0 pa-0 mb-3"
                        :error-messages="errors"
                        color="primary"
                      />
                    </validation-provider>
                    <validation-provider
                      v-slot="{ errors }"
                      name="Đơn giá"
                      :vid="'Đơn giá' + index"
                      :rules="{required: true, numeric: true, regex: /^[0-9]+$/, min_value:0}"
                    >
                      <v-text-field
                        :readonly="isReadOnly"
                        step="5000"
                        type="number"
                        v-model="product.price"
                        label="Đơn giá"
                        class="ma-0 pa-0 mb-3"
                        :error-messages="errors"
                        color="primary"
                      />
                    </validation-provider>
                    <v-currency-field class="ma-0 pa-0" readonly :value="(product.price * product.quantity)" />
                    <!-- <validation-provider
                      v-slot="{ errors }"
                      :vid="'Tên đại lý' + index"
                      name="Tên đại lý"
                      rules="required"
                    >
                      <v-autocomplete
                        :disabled="isReadOnly || !product.productId"
                        v-model="product.agencyId"
                        :items="agencyList"
                        :menu-props="{ maxHeight: '250',maxWidth: '250',bottom: true, offsetY: true }"
                        item-text="name"
                        item-value="id"
                        class="ma-0 pa-0"
                        :error-messages="errors"
                        label="Tên đại lý"
                      />
                    </validation-provider> -->
                    <div v-show="index > 0 && !isReadOnly" class="text-left" style="position: relative">
                      
                    </div>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <div>
                <v-btn small v-if="!isReadOnly" class="add-product-btn px-0" @click="onClickAddProduct">
                  <v-icon>mdi-plus</v-icon><span class="add-product-text">Thêm sản phẩm</span>
                </v-btn>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col cols="12" class="pb-0">
        <validation-provider
          v-slot="{ errors }"
          name="Chiết khấu (%)"
          :rules="{
            required: true,
            min_value: 0,
            max_value: 100,
          }"
        >
          <v-text-field
            type="number"
            label="Chiết khấu (%)"
            min="0"
            max="100"
            :error-messages="errors"
            v-model.number="contentOrder.discount"
          ></v-text-field>
        </validation-provider>
        <v-currency-field readonly label="Tổng giá trị sau khi chiết khấu" :value="afterDiscount" />
        
        <validation-provider
          v-slot="{ errors }"
          name="Đã thanh toán"
          :rules="{
            required: true,
            min_value: 0,
            max_value: totalPrice,
          }"
        >
          <v-currency-field
            :readonly="isReadOnly"
            label="Đã thanh toán"
            :error-messages="errors"
            class="ma-0 pa-0"
            v-model="contentOrder.paidAmount"
          />
        </validation-provider>
        <v-currency-field readonly label="Còn lại" :value="restPrice" />
        <validation-provider v-slot="{ errors }" name="Hình thức thanh toán" rules="required">
          <v-autocomplete
            :disabled="isReadOnly"
            v-model="contentOrder.paymentType"
            :items="orderPaymentTypes"
            label="Hình thức thanh toán *"
            class="ma-0 pa-0"
            :error-messages="errors"
          />
        </validation-provider>
        <validation-provider v-slot="{ errors }" name="Ghi chú đơn hàng" rules="max:255">
          <v-textarea
            :readonly="isReadOnly"
            label="Ghi chú đơn hàng"
            rows="3"
            class="ma-0 pa-0"
            v-model="contentOrder.description"
            :error-messages="errors"
          />
        </validation-provider>
        <!-- <v-autocomplete
          v-if="!contentOrder.isDetail"
          :readonly="isReadOnly"
          v-model="contentOrder.statusId"
          :items="getStatusList"
          item-text="name"
          item-value="id"
          label="Trạng thái"
        /> -->
      </v-col>
      <v-col cols="12" sm="12" class="py-0">
        <ul class="table-info">
          <li class="mb-2">
            <strong>Địa chỉ đại lý</strong>
          </li>
          <li class="mb-1">
            <p class="ma-0">
              <span class="font-weight-medium">Số điện thoại :</span>
              {{fullNamePhone}}
              <v-tooltip v-if="showChat" bottom>
                <template v-slot:activator="{ on }">
                    <v-btn class="icon-fb" icon small color="info" v-on="on"><v-icon>mdi-facebook-messenger</v-icon></v-btn>
                </template>
                <span>Nhắn tin</span>
            </v-tooltip>
            </p>
          </li>
          <li class="mb-1">
            <p class="ma-0">
              <span class="font-weight-medium">Địa chỉ :</span>
              {{_.get(shippingAddress, 'detailAddress', '')}}
            </p>
          </li>
          <li class="mb-1">
            <p class="ma-0">{{provinceAddress}}</p>
          </li>
        </ul>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { orderPaymentTypes } from '../../../helpers/constants';

export default {
  props: {
    dataForm: {
      type: Object,
      default: () => {}
    },
    contentOrder: {
      type: Object,
      default: () => {}
    },
    contactStatus: {
      type: Object,
      default: () => ({})
    },
    contactStatusList: {
      type: Array,
      default: () => []
    },
    shippingAddress: {
      type: Object,
      default: () => {}
    },
    courseRegisters: {
      type: Array,
      default: () => []
    },
    agencyList: {
      type: Array,
      default: () => []
    },
    stepOrder: {
      type: Number,
      default: -1
    },
    showChat: {
      type: Boolean,
      default: false
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      orderPaymentTypes,
      panel: [0]
    };
  },
  computed: {
    getStatusList() {
      let charFirstType =
        _.get(this.contactStatus, 'type', 'T').charAt(0) || 'T';
      const contactStatusList = [];
      const checkType = {};
      this.contactStatusList.forEach(contactStatus => {
        const typeContactStatus = contactStatus.type;
        if (typeContactStatus.includes(charFirstType)) {
          if (!checkType[typeContactStatus]) {
            checkType[typeContactStatus] = true;
            if (contactStatusList.length > 0) {
              contactStatusList.push({ divider: true });
            }
            contactStatusList.push({ header: typeContactStatus });
          }
          contactStatusList.push(contactStatus);
        }
      });
      return contactStatusList;
    },
    dataStatus() {
      return `Trạng thái: (${_.get(this.contactStatus, 'type', '')}-${_.get(
        this.contactStatus,
        'name',
        ''
      )})`;
    },
    dataStatusCTV() {
      let stt = ""
      if (this.contentOrder.statusId == 1) {
        stt = "Lên đơn"
      }
      if (this.contentOrder.statusId == 2) {
        stt = "Đang giao hàng"
      }
      if (this.contentOrder.statusId == 3) {
        stt = "Đã thành công"
      }
      if (this.contentOrder.statusId == 4) {
        stt = "Đã hoàn"
      }
      if (this.contentOrder.statusId == 5) {
        stt = "Đã hủy"
      }
      return `Trạng thái: ${stt}`;
    },
    afterDiscount() {
      let price = (this.totalPrice * Number(this.contentOrder.discount) / 100);
      return this.totalPrice - price
    },
    restPrice() {
      return this.afterDiscount - Number(this.contentOrder.paidAmount);
    },
    fullNamePhone() {
      return `${_.get(this.shippingAddress, 'phone', '')}`;
    },
    provinceAddress() {
      return `${_.get(this.shippingAddress, 'xaName', '')} ${_.get(
        this.shippingAddress,
        'huyenName',
        ''
      )} ${_.get(this.shippingAddress, 'tinhName', '')}`;
    },
    totalPrice() {
      return (
        _.get(this.contentOrder, 'products', []).reduce(
          (accumulator, product) => {
            return (
              accumulator +
              _.get(product, 'price', 0) * _.get(product, 'quantity', 0)
            );
          },
          0
        ) || 0
      );
    }
  },
  methods: {
    onClickRemoteProduct(index) {
      this.$swal({
        title: 'Xóa sản phẩm',
        text: 'Bạn có thực sự muốn xoá ?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy bỏ'
      }).then(async result => {
        if (result.value) {
          this.contentOrder.products.splice(index, 1);
        }
      });
    },
    onClickAddProduct() {
      this.contentOrder.products.push({
        productId: '',
        quantity: 1,
        price: 0,
        agencyId: this.shippingAddress.id,
        productType: '',
        name: '',
        endDate: '',
        code: ''          
      });
    },
    changeProduct(product) {
      const productTemp = product;
      const data = this.courseRegisters.find(
        courseRegister => courseRegister.id === productTemp.productId
      );
      productTemp.agencyId = this.shippingAddress.id;
      productTemp.price = data.price ?? data.products[0].price;
      productTemp.productType = data.group ? 'product' : 'combo';
      productTemp.name = data.name;
      productTemp.endDate = data.products ? data.products[0].endDate : data.endDate;
      productTemp.endMonth = data.products ? data.products[0].endMonth : data.endMonth;
      productTemp.code = data.code;
    }
  }
};
</script>

<style scoped>
/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}

.add-product-btn {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #2196F3 !important;
  box-shadow: unset;
  text-underline-position: under;
  font-weight: bold;
}

.add-product-btn .add-product-text {
  text-decoration: underline;
  text-underline-position: under;
}

.delete-product-btn {
  background-color: transparent !important;
  border-color: transparent !important;
  color: #F44336 !important;
  box-shadow: unset;
  text-underline-position: under;
  font-weight: bold;
  position: absolute;
  right: 20px;
}

.delete-product-btn .delete-product-text {
  text-decoration: underline;
  text-underline-position: under;
}
</style>
